// Single permanent shared patient asset.
// Intended local path: /public/images/shared-patient.webp
// Currently pointing at the uploaded static asset until the binary file is
// placed into /public/images/. Swap this one constant when the local file
// is available — nothing else needs to change.
export const SHARED_PATIENT_IMAGE =
  "https://static.readdy.ai/image/ef1aae41220ad17a1705abffff22a58b/7d58d47e46d8546c093052ca9ac4d2f4.png";